<form novalidate (ngSubmit)="save()" #formClientInfo="ngForm">
    <div class="card-body mt-0 pt-4">
        <div class="row">
            <div class="col-lg-3 separator-vertical mb-3">
                <div class="form-group">
                    <h6>Patient Vitals</h6>
                </div>
                <table class="table table-sm">
                    <tbody>
                        <tr>
                            <td class="form-label-sm">Respiration <small>Rate/Min</small>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag3"
                                    [(ngModel)]="petService.pet_vitals.tag3" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Heart <small>Rate/Min</small>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag4"
                                    [(ngModel)]="petService.pet_vitals.tag4" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Temperature:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag2"
                                    [(ngModel)]="petService.pet_vitals.tag2" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">SpO<sub>2</sub>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag31"
                                    [(ngModel)]="petService.pet_vitals.tag31" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">ETCO<sub>2</sub>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag32"
                                    [(ngModel)]="petService.pet_vitals.tag32" />
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">BP<br><small>Sys/Dia (mm Hg)</small>:</td>
                            <td>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag5"
                                    [(ngModel)]="petService.pet_vitals.tag5" />
                            </td>
                        </tr>
                        
                    </tbody>
                </table>
            </div>
            <div class="col-lg-4 mb-3 separator-vertical">
                <div class="form-group">
                    <h6>Subjetive</h6>
                </div>
                <table class="table table-sm">
                    <tbody>
                        <tr>
                            <td class="form-label-sm">Hydration:</td>
                            <td>
                                <select class="form-control form-select-sm" autocomplete="off" name="_tag30"
                                    [(ngModel)]="petService.pet_vitals.tag30">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of HYDRATION">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Heart Sounds:</td>
                            <td>
                            <select class="form-control form-select-sm" autocomplete="off" name="_tag34"
                            [(ngModel)]="petService.pet_vitals.tag34">
                                <option value=""></option>
                                <option [value]="item.description" *ngFor="let item of HEARTH_SOUNDS">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Lung Sounds:</td>
                            <td>
                                <select class="form-control form-select-sm" autocomplete="off" name="_tag33"
                                    [(ngModel)]="petService.pet_vitals.tag33">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of LUNG_SOUNDS">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Pulse Quality:</td>
                            <td>
                                <select class="form-control form-select-sm" autocomplete="off" name="_tag37"
                                    [(ngModel)]="petService.pet_vitals.tag37">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of PULSE_QUALITY">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">MM color:</td>
                            <td>
                                <select class="form-control form-select-sm" autocomplete="off" name="_tag38"
                                    [(ngModel)]="petService.pet_vitals.tag38">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of MM_COLOR">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">CRT:</td>
                            <td>
                                <select class="form-control form-select-sm" autocomplete="off" name="_tag39"
                                    [(ngModel)]="petService.pet_vitals.tag39">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of CRT">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                        </tr>
                    </tbody>    
                </table>
                
                
            </div>
            <div class="col-lg-5 mb-3">
                <div class="form-group">
                    <h6>Anesthesia/Support</h6>
                </div>
                <table class="table table-sm">
                    <tbody>
                        <tr>
                            <td class="form-label-sm" style="width: 20%;">Anesthetic:</td>
                            <td style="width: 40%;">
                                <select class="form-control form-select-sm" name="_tag26"
                                    [(ngModel)]="petService.pet_vitals.tag26">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of MONITOR_ANES">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                            <td style="width: 40%;">
                                <div class="input-group input-group-sm">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Rate:</span>
                                    </div>
                                    <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag26bis"
                                        [(ngModel)]="petService.pet_vitals.tag26bis" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Fluids:</td>
                            <td>
                                <select class="form-control form-select-sm" name="_tag27"
                                    [(ngModel)]="petService.pet_vitals.tag27">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of MONITOR_FLUIDS">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>

                            <td>
                                <div class="input-group input-group-sm">
                                    <div class="input-group-prepend">
                                        <span class="input-group-text">Rate:</span>
                                    </div>
                                <input type="text" class="form-control form-control-sm" autocomplete="off" name="_tag27bis"
                                    [(ngModel)]="petService.pet_vitals.tag27bis" />
                                </div>
                            </td>
                        </tr>
                        <tr>
                            <td class="form-label-sm">Breathing:</td>
                            <td>
                                <select class="form-control form-select-sm" name="_tag28"
                                    [(ngModel)]="petService.pet_vitals.tag28">
                                    <option value=""></option>
                                    <option [value]="item.description" *ngFor="let item of MONITOR_BREATH">
                                        {{ item.description }}
                                    </option>
                                </select>
                            </td>
                            <td>
                               
                            </td>
                        </tr>
                        <tr>
                            <td colspan="3">
                                <h6 class="w-100 d-block mt-5">Procedure Notes</h6>
                                <textarea rows="5" class="form-control form-control-sm"></textarea>
                            </td>
                        </tr>
                    </tbody>
                </table>

            </div>
        </div>
       
    </div>
    <div class="card-footer text-right py-4">

        <button type="submit" class="btn btn-primary">
            Save Changes
        </button>
    </div>
</form>